<div class="hint-wrapper">
  <mat-hint class="hint-validation mat-form-field">
    <app-hint-error-message [hint]="hint" ></app-hint-error-message>
  </mat-hint>
</div>
